const http = require("./http-common.js").http;

import i18n from "@/i18n";
import store from "@/store";

export function get(path, config) {
  return http
    .get(path, config)
    .then((response) => response.data)
    .catch((ex) => onError(ex));
}

export function post(path, data, config) {
  return http
    .post(path, data, config)
    .then((response) => response.data)
    .catch((ex) => onError(ex));
}

export function downloadFile(url) {
  var config = {
    responseType: "blob",
  };
  return http
    .get(url, config)
    .then((response) => {
      let fileURL = window.URL.createObjectURL(new Blob([response.data]));
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;

      // Get filename from axios response
      const fileField = "filename=";
      let hearderContent = response.headers["content-disposition"].split(";");
      let filenameField = hearderContent.find(
        (field) => field && field.includes(fileField)
      );
      let filename = filenameField
        .replace(fileField, "")
        .replaceAll('"', "")
        .trim();

      fileLink.setAttribute("download", filename);
      document.body.appendChild(fileLink);
      fileLink.click();
    })
    .catch((ex) => onError(ex));
}

export function put(path, data) {
  return http
    .put(path, data)
    .then((response) => response.data)
    .catch((ex) => onError(ex));
}

export function postForm(url, data) {
  var config = {
    headers: {
      "Content-type": "multipart/form-data",
    },
  };
  return post(url, data, config);
}

export function remove(path, data) {
  return http
    .delete(path, { data: data })
    .then((response) => response.data)
    .catch((ex) => onError(ex));
}

export function getIframeToken(endpoint, ...params) {
  return post(`${endpoint}/iframe-token/${params.join("/")}`);
}

const onError = async (ex) => {
  let data = ex.response?.data;
  if (data instanceof Blob) {
    data = JSON.parse(await data?.text());
  }
  if (ex.response.status === 403) {
    store.commit("clear");
  }
  if (ex.response.status === 429) {
    const retryAfter = ex.response.headers?.["retry-after"];
    data = i18n.t("global.msg.error-upload-limit", [retryAfter]);
  }
  // Handle ErrorDto format with message (translation key) and arguments
  if (data?.message && i18n.te(data.message)) {
    data = i18n.t(data.message, data.arguments || []);
  }
  return new Promise(() => {
    throw data;
  });
};
